// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"merge-cells"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 3L21 3L21 21L3 21L3 3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 7V3M12 21V17M3 3V21H21V3H3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M8.33008 13.768L10.0978 12.0002L8.33008 10.2324M15.768 10.2321L14.0002 11.9998L15.768 13.7676","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const MergeCellsIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'merge-cells',
    ref,
    icon: element,
  },
));

MergeCellsIcon.displayName = 'MergeCellsIcon';

export default MergeCellsIcon;
